export default __webpack_public_path__ + "static/media/hht2_storybook_03.773b06fd.png";